/**
 * Reads flex value from computed styles of a panel element
 * Returns the flex-grow value, or 1 as default if not found
 */
export const getFlexValue = (element: HTMLElement): number => {
  const computedStyle = window.getComputedStyle(element);
  const flex = computedStyle.flex;
  const flexGrow = computedStyle.flexGrow;

  // If flex shorthand is set, parse it (handling multiple spaces)
  if (flex && flex !== "none" && flex !== "0 0 auto") {
    const parts = flex.trim().split(/\s+/);
    const grow = parseFloat(parts[0] || "1");
    if (!Number.isNaN(grow) && grow >= 0) {
      return grow;
    }
  }

  // Otherwise use flex-grow
  const grow = parseFloat(flexGrow || "1");
  const result = Number.isNaN(grow) || grow < 0 ? 1 : grow;
  return result;
};

/**
 * Sets flex value on a panel element via direct DOM manipulation
 * Format: flex-grow flex-shrink flex-basis
 * Uses flex-shrink: 1 for standard proportional shrinking behavior
 */
export const setFlexValue = (element: HTMLElement, value: number): void => {
  element.style.flex = `${value} 1 0`;
};

/**
 * Normalizes flex values to ensure minimum of 1 (prevents unresizable panels)
 */
export const normalizeFlexValues = (values: [number, number]): [number, number] => {
  const [first, second] = values;
  return [first === 0 ? 1 : first, second === 0 ? 1 : second];
};
